module.exports = __webpack_public_path__ + "img/bolle-bg.8b608753.jpg";